import React from 'react';
import { Target, Heart, Lightbulb, Smile } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { visionContent } from '../mock';

export const Vision = () => {
  const valueIcons = {
    'Accessibilité et Nature': Target,
    'Innovation et Sécurité': Lightbulb,
    'Respect Animal': Heart,
    'Plaisir': Smile
  };

  return (
    <div className="vision-page">
      {/* Header */}
      <section className="page-header">
        <div className="container">
          <h1 className="page-title">Notre Vision</h1>
          <p className="page-description">
            Créer un monde où la nature n'a aucune barrière.
          </p>
        </div>
      </section>

      {/* Story */}
      <section className="story-section">
        <div className="container">
          <div className="story-content">
            <h2 className="section-title">Notre Histoire</h2>
            <div className="story-text-container">
              <p className="story-text">
                Pégase est né d'une conviction : la nature ne devrait avoir aucune barrière. 
                Nous avons créé des attelages qui allient innovation technologique et respect 
                absolu du bien-être animal pour permettre à chacun de vivre l'expérience unique 
                de la nature sauvage.
              </p>
              <p className="story-text">
                Simon Mulholland travaille depuis plus de 20 ans à l'innovation et la conception 
                d'attelages les plus sûrs possibles. Les derniers développements offrent la 
                possibilité à des personnes en situation de handicap :
              </p>
              <ul className="story-list">
                <li>d'avoir accès à des sites naturels exceptionnels</li>
                <li>de pouvoir être autonome si ils le souhaitent</li>
                <li>de découvrir les plaisirs équestres</li>
              </ul>
            </div>
            <div className="story-image">
              <img
                src="https://customer-assets.emergentagent.com/job_equi-mobility/artifacts/rjd2ubev_IMG_6950.jpg"
                alt="Pégase en action"
                className="story-img"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="values-section">
        <div className="container">
          <h2 className="section-title">Nos Valeurs</h2>
          <div className="values-grid">
            {visionContent.values.map((value, index) => {
              const IconComponent = valueIcons[value.title];
              return (
                <Card key={index} className="value-card">
                  <CardContent className="value-card-content">
                    <IconComponent className="value-icon" size={48} />
                    <h3 className="value-title">{value.title}</h3>
                    <p className="value-description">{value.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Impact */}
      <section className="impact-section">
        <div className="container">
          <h2 className="section-title">Notre Impact</h2>
          <div className="impact-stats">
            <Card className="stat-card">
              <CardContent className="stat-content">
                <div className="stat-number">2000</div>
                <div className="stat-label">Sorties avec 0 accidents</div>
              </CardContent>
            </Card>
            <Card className="stat-card">
              <CardContent className="stat-content">
                <div className="stat-number">3</div>
                <div className="stat-label">Niveaux de sécurité</div>
              </CardContent>
            </Card>
            <Card className="stat-card">
              <CardContent className="stat-content">
                <div className="stat-number">100%</div>
                <div className="stat-label">Accessibilité nature</div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Vision;
